module.exports = __webpack_public_path__ + "img/ico_add_file.156c8511.svg";